var timezone = {
    getTimezone: function(latitude, longitude, callback) {
        var options = {
            sensor: false,
            timestamp: Math.round((new Date()).getTime() / 1000),
            location: latitude + ',' + longitude
        };
        
        $.get('https://maps.googleapis.com/maps/api/timezone/json?' + $.param(options))
            .done(function(data) {
                callback(data);
            })
            .fail(function(request, status, error) {
                console.error(error);
            });
    }
};

module.exports = timezone;
